// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-table {
    width: 100%;
}
  
.list-group-item {
    padding: 1rem 1rem;
    border: 2.5px solid #f09502;
    margin-top: 15px;
    border-radius: 8px;
    color: white;
    background: transparent;
    transition: all 0.3s ease;
}

.list-group-item:hover {
    background: rgba(240, 149, 2, 0.1);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.column-tittle {
    color: white !important;
}

.column-tittle div {
    color: white !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
}

/* Estilos para filtros */
.card {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(240, 149, 2, 0.3);
    border-radius: 12px;
}

.card-header {
    background: rgba(240, 149, 2, 0.2);
    border-bottom: 1px solid rgba(240, 149, 2, 0.3);
    color: white;
}

.form-control, .form-select {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(240, 149, 2, 0.3);
    color: white;
    border-radius: 8px;
}

.form-select option {
    background-color: #2c2c2c !important;
    color: white !important;
    padding: 8px 12px;
}

.form-select:focus {
    background: rgba(255, 255, 255, 0.15);
    border-color: #f09502;
    box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.25);
    color: white;
}

.form-control:focus, .form-select:focus {
    background: rgba(255, 255, 255, 0.15);
    border-color: #f09502;
    box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.25);
    color: white;
}

.form-control::placeholder {
    color: rgba(255, 255, 255, 0.6);
}

.form-label {
    color: white;
    font-weight: 500;
    margin-bottom: 0.5rem;
}

/* Estilos para badges */
.badge {
    font-size: 0.75rem;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
}

.badge.bg-primary {
    background-color: #f09502 !important;
}

.badge.bg-success {
    background-color: #28a745 !important;
}

.badge.bg-danger {
    background-color: #dc3545 !important;
}

.badge.bg-warning {
    background-color: #ffc107 !important;
    color: #000;
}

.badge.bg-secondary {
    background-color: #6c757d !important;
}

/* Estilos para botones */
.btn-sm {
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    border-radius: 6px;
    font-weight: 500;
}

.btn-outline-secondary {
    color: #f09502;
    border-color: #f09502;
}

.btn-outline-secondary:hover {
    background-color: #f09502;
    border-color: #f09502;
    color: white;
}

.btn-outline-primary {
    color: #f09502;
    border-color: #f09502;
}

.btn-outline-primary:hover {
    background-color: #f09502;
    border-color: #f09502;
    color: white;
}

/* Estilos para alertas */
.alert-info {
    background-color: rgba(23, 162, 184, 0.2);
    border-color: rgba(23, 162, 184, 0.3);
    color: white;
}

/* Estilos para estado vacío */
.empty-state {
    padding: 3rem 2rem;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.05);
    border: 2px dashed rgba(240, 149, 2, 0.3);
}

.empty-state i {
    color: #f09502 !important;
}

.empty-state-icon {
    font-size: 3rem !important;
    color: #ccc !important;
}

.empty-state h4 {
    color: white !important;
}

.empty-state p {
    color: rgba(255, 255, 255, 0.7) !important;
}

/* Iconos */
.bi {
    font-size: 1rem;
}

.domo-color {
    color: #f09502;
}

/* Estilos para fechas en desktop */
.col-2 small {
    color: white !important;
    font-weight: 500;
}

.col-2 .bi {
    color: #f09502;
    margin-right: 0.25rem;
}

/* Estilos para select pequeño */
.form-select-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    border-radius: 0.25rem;
}

.form-select-sm:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Layout móvil */
@media (max-width: 768px) {
    .list-group-item {
        padding: 1.25rem 0.5rem;
        margin-bottom: 1rem;
    }
    
    .list-group-item .row {
        display: flex;
        flex-direction: column;
        gap: 0;
    }
    
    .list-group-item .col-2 {
        width: 100% !important;
        max-width: 100% !important;
        flex: 0 0 100% !important;
        margin-bottom: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.75rem 1.5rem;
        border-bottom: 1px solid rgba(240, 149, 2, 0.15);
        min-height: 50px;
    }
    
    .list-group-item .col-2:last-child {
        border-bottom: none;
    }
    
    .column-tittle {
        display: none !important;
    }
    
    .badge {
        font-size: 0.8rem !important;
        padding: 0.5rem 0.75rem !important;
        font-weight: 600 !important;
        border-radius: 6px !important;
        min-width: 80px;
        text-align: center;
    }
    
    .form-select-sm {
        width: 100%;
        margin-top: 0.5rem;
    }
}

/* Animaciones */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.list-group-item {
    animation: fadeIn 0.3s ease-out;
}

/* Estilos para texto truncado */
.text-truncate {
    max-width: 200px;
}

/* Estilos para el textarea de notas */
.notes-textarea {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(240, 149, 2, 0.3);
    color: white;
    border-radius: 6px;
    font-size: 0.75rem;
}

.notes-textarea:focus {
    background: rgba(255, 255, 255, 0.15);
    border-color: #f09502;
    box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.25);
    color: white;
}

.notes-textarea::placeholder {
    color: rgba(255, 255, 255, 0.5);
}

/* Estilos para el enlace del proyecto */
.text-white-50 {
  color: rgba(255, 255, 255, 0.7) !important;
  transition: color 0.3s ease;
}

.text-white-50:hover {
  color: #f09502 !important;
}

/* Estilos para la tarjeta de detalles desplegable */
.card.border-secondary {
  border-color: rgba(240, 149, 2, 0.5) !important;
  background: rgba(0, 0, 0, 0.3) !important;
}

.card.border-secondary h6 {
  color: #f09502 !important;
}

/* Mejorar legibilidad de los detalles de transacción */
.transaction-details {
  background: rgba(0, 0, 0, 0.5) !important;
}

.transaction-details .text-light {
  color: rgba(255, 255, 255, 0.9) !important;
  font-weight: 400;
}

.transaction-details strong {
  color: rgba(255, 255, 255, 1) !important;
  font-weight: 600;
}

/* Espaciado mejorado entre columnas - solo en las filas de datos */
.list-group-item .row > div {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

/* Espaciado adicional entre Estado y Acciones para evitar que se toquen */
.list-group-item .row > div:nth-last-child(2) {
  padding-right: 1rem;
}

/* Estilos para paginación */
.pagination {
  --bs-pagination-color: #f09502;
  --bs-pagination-hover-color: #fff;
  --bs-pagination-hover-bg: rgba(240, 149, 2, 0.2);
  --bs-pagination-hover-border-color: #f09502;
  --bs-pagination-focus-color: #fff;
  --bs-pagination-focus-bg: rgba(240, 149, 2, 0.2);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(240, 149, 2, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #f09502;
  --bs-pagination-active-border-color: #f09502;
  --bs-pagination-disabled-color: rgba(255, 255, 255, 0.5);
  --bs-pagination-disabled-bg: transparent;
  --bs-pagination-disabled-border-color: rgba(240, 149, 2, 0.3);
}

.page-link {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(240, 149, 2, 0.3);
  color: rgba(255, 255, 255, 0.8);
}

.page-link:hover {
  background-color: rgba(240, 149, 2, 0.2);
  border-color: #f09502;
  color: #fff;
}

.page-item.active .page-link {
  background-color: #f09502;
  border-color: #f09502;
  color: #fff;
}

.page-item.disabled .page-link {
  background-color: transparent;
  border-color: rgba(240, 149, 2, 0.3);
  color: rgba(255, 255, 255, 0.5);
  cursor: not-allowed;
}

/* Mejoras de accesibilidad */
.btn:focus {
    box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.5);
}

.form-control:focus,
.form-select:focus {
    outline: none;
}

/* Estilos para el contador de resultados */
.alert {
    border-radius: 8px;
    margin-bottom: 1.5rem;
}

`, "",{"version":3,"sources":["webpack://./src/app/components/reserves-management/reserves-management.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,yBAAyB;AACzB;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,+CAA+C;IAC/C,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,wCAAwC;IACxC,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;IACrB,gDAAgD;IAChD,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;IACrB,gDAAgD;IAChD,YAAY;AAChB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,oCAAoC;AACxC;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;AAChB;;AAEA,yBAAyB;AACzB;IACI,yCAAyC;IACzC,qCAAqC;IACrC,YAAY;AAChB;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,mBAAmB;IACnB,qCAAqC;IACrC,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA,WAAW;AACX;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA,mCAAmC;AACnC;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA,gCAAgC;AAChC;IACI,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI;QACI,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,MAAM;IACV;;IAEA;QACI,sBAAsB;QACtB,0BAA0B;QAC1B,yBAAyB;QACzB,gBAAgB;QAChB,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,uBAAuB;QACvB,gDAAgD;QAChD,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;QAC5B,kCAAkC;QAClC,2BAA2B;QAC3B,6BAA6B;QAC7B,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA,gBAAgB;AAChB;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,+BAA+B;AACnC;;AAEA,gCAAgC;AAChC;IACI,gBAAgB;AACpB;;AAEA,sCAAsC;AACtC;IACI,oCAAoC;IACpC,wCAAwC;IACxC,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;IACrB,gDAAgD;IAChD,YAAY;AAChB;;AAEA;IACI,+BAA+B;AACnC;;AAEA,wCAAwC;AACxC;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oDAAoD;AACpD;EACE,+CAA+C;EAC/C,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uDAAuD;AACvD;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,0EAA0E;AAC1E;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,gDAAgD;EAChD,2CAA2C;EAC3C,iCAAiC;EACjC,gDAAgD;EAChD,uEAAuE;EACvE,kCAAkC;EAClC,kCAAkC;EAClC,4CAA4C;EAC5C,wDAAwD;EACxD,wCAAwC;EACxC,6DAA6D;AAC/D;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;IACI,+CAA+C;AACnD;;AAEA;;IAEI,aAAa;AACjB;;AAEA,2CAA2C;AAC3C;IACI,kBAAkB;IAClB,qBAAqB;AACzB","sourcesContent":[".custom-table {\n    width: 100%;\n}\n  \n.list-group-item {\n    padding: 1rem 1rem;\n    border: 2.5px solid #f09502;\n    margin-top: 15px;\n    border-radius: 8px;\n    color: white;\n    background: transparent;\n    transition: all 0.3s ease;\n}\n\n.list-group-item:hover {\n    background: rgba(240, 149, 2, 0.1);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.column-tittle {\n    color: white !important;\n}\n\n.column-tittle div {\n    color: white !important;\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n}\n\n/* Estilos para filtros */\n.card {\n    background: rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(240, 149, 2, 0.3);\n    border-radius: 12px;\n}\n\n.card-header {\n    background: rgba(240, 149, 2, 0.2);\n    border-bottom: 1px solid rgba(240, 149, 2, 0.3);\n    color: white;\n}\n\n.form-control, .form-select {\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(240, 149, 2, 0.3);\n    color: white;\n    border-radius: 8px;\n}\n\n.form-select option {\n    background-color: #2c2c2c !important;\n    color: white !important;\n    padding: 8px 12px;\n}\n\n.form-select:focus {\n    background: rgba(255, 255, 255, 0.15);\n    border-color: #f09502;\n    box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.25);\n    color: white;\n}\n\n.form-control:focus, .form-select:focus {\n    background: rgba(255, 255, 255, 0.15);\n    border-color: #f09502;\n    box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.25);\n    color: white;\n}\n\n.form-control::placeholder {\n    color: rgba(255, 255, 255, 0.6);\n}\n\n.form-label {\n    color: white;\n    font-weight: 500;\n    margin-bottom: 0.5rem;\n}\n\n/* Estilos para badges */\n.badge {\n    font-size: 0.75rem;\n    padding: 0.5rem 0.75rem;\n    border-radius: 6px;\n}\n\n.badge.bg-primary {\n    background-color: #f09502 !important;\n}\n\n.badge.bg-success {\n    background-color: #28a745 !important;\n}\n\n.badge.bg-danger {\n    background-color: #dc3545 !important;\n}\n\n.badge.bg-warning {\n    background-color: #ffc107 !important;\n    color: #000;\n}\n\n.badge.bg-secondary {\n    background-color: #6c757d !important;\n}\n\n/* Estilos para botones */\n.btn-sm {\n    padding: 0.375rem 0.75rem;\n    font-size: 0.875rem;\n    border-radius: 6px;\n    font-weight: 500;\n}\n\n.btn-outline-secondary {\n    color: #f09502;\n    border-color: #f09502;\n}\n\n.btn-outline-secondary:hover {\n    background-color: #f09502;\n    border-color: #f09502;\n    color: white;\n}\n\n.btn-outline-primary {\n    color: #f09502;\n    border-color: #f09502;\n}\n\n.btn-outline-primary:hover {\n    background-color: #f09502;\n    border-color: #f09502;\n    color: white;\n}\n\n/* Estilos para alertas */\n.alert-info {\n    background-color: rgba(23, 162, 184, 0.2);\n    border-color: rgba(23, 162, 184, 0.3);\n    color: white;\n}\n\n/* Estilos para estado vacío */\n.empty-state {\n    padding: 3rem 2rem;\n    border-radius: 12px;\n    background: rgba(255, 255, 255, 0.05);\n    border: 2px dashed rgba(240, 149, 2, 0.3);\n}\n\n.empty-state i {\n    color: #f09502 !important;\n}\n\n.empty-state-icon {\n    font-size: 3rem !important;\n    color: #ccc !important;\n}\n\n.empty-state h4 {\n    color: white !important;\n}\n\n.empty-state p {\n    color: rgba(255, 255, 255, 0.7) !important;\n}\n\n/* Iconos */\n.bi {\n    font-size: 1rem;\n}\n\n.domo-color {\n    color: #f09502;\n}\n\n/* Estilos para fechas en desktop */\n.col-2 small {\n    color: white !important;\n    font-weight: 500;\n}\n\n.col-2 .bi {\n    color: #f09502;\n    margin-right: 0.25rem;\n}\n\n/* Estilos para select pequeño */\n.form-select-sm {\n    padding: 0.25rem 0.5rem;\n    font-size: 0.875rem;\n    border-radius: 0.25rem;\n}\n\n.form-select-sm:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* Layout móvil */\n@media (max-width: 768px) {\n    .list-group-item {\n        padding: 1.25rem 0.5rem;\n        margin-bottom: 1rem;\n    }\n    \n    .list-group-item .row {\n        display: flex;\n        flex-direction: column;\n        gap: 0;\n    }\n    \n    .list-group-item .col-2 {\n        width: 100% !important;\n        max-width: 100% !important;\n        flex: 0 0 100% !important;\n        margin-bottom: 0;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 0.75rem 1.5rem;\n        border-bottom: 1px solid rgba(240, 149, 2, 0.15);\n        min-height: 50px;\n    }\n    \n    .list-group-item .col-2:last-child {\n        border-bottom: none;\n    }\n    \n    .column-tittle {\n        display: none !important;\n    }\n    \n    .badge {\n        font-size: 0.8rem !important;\n        padding: 0.5rem 0.75rem !important;\n        font-weight: 600 !important;\n        border-radius: 6px !important;\n        min-width: 80px;\n        text-align: center;\n    }\n    \n    .form-select-sm {\n        width: 100%;\n        margin-top: 0.5rem;\n    }\n}\n\n/* Animaciones */\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.list-group-item {\n    animation: fadeIn 0.3s ease-out;\n}\n\n/* Estilos para texto truncado */\n.text-truncate {\n    max-width: 200px;\n}\n\n/* Estilos para el textarea de notas */\n.notes-textarea {\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(240, 149, 2, 0.3);\n    color: white;\n    border-radius: 6px;\n    font-size: 0.75rem;\n}\n\n.notes-textarea:focus {\n    background: rgba(255, 255, 255, 0.15);\n    border-color: #f09502;\n    box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.25);\n    color: white;\n}\n\n.notes-textarea::placeholder {\n    color: rgba(255, 255, 255, 0.5);\n}\n\n/* Estilos para el enlace del proyecto */\n.text-white-50 {\n  color: rgba(255, 255, 255, 0.7) !important;\n  transition: color 0.3s ease;\n}\n\n.text-white-50:hover {\n  color: #f09502 !important;\n}\n\n/* Estilos para la tarjeta de detalles desplegable */\n.card.border-secondary {\n  border-color: rgba(240, 149, 2, 0.5) !important;\n  background: rgba(0, 0, 0, 0.3) !important;\n}\n\n.card.border-secondary h6 {\n  color: #f09502 !important;\n}\n\n/* Mejorar legibilidad de los detalles de transacción */\n.transaction-details {\n  background: rgba(0, 0, 0, 0.5) !important;\n}\n\n.transaction-details .text-light {\n  color: rgba(255, 255, 255, 0.9) !important;\n  font-weight: 400;\n}\n\n.transaction-details strong {\n  color: rgba(255, 255, 255, 1) !important;\n  font-weight: 600;\n}\n\n/* Espaciado mejorado entre columnas - solo en las filas de datos */\n.list-group-item .row > div {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n/* Espaciado adicional entre Estado y Acciones para evitar que se toquen */\n.list-group-item .row > div:nth-last-child(2) {\n  padding-right: 1rem;\n}\n\n/* Estilos para paginación */\n.pagination {\n  --bs-pagination-color: #f09502;\n  --bs-pagination-hover-color: #fff;\n  --bs-pagination-hover-bg: rgba(240, 149, 2, 0.2);\n  --bs-pagination-hover-border-color: #f09502;\n  --bs-pagination-focus-color: #fff;\n  --bs-pagination-focus-bg: rgba(240, 149, 2, 0.2);\n  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(240, 149, 2, 0.25);\n  --bs-pagination-active-color: #fff;\n  --bs-pagination-active-bg: #f09502;\n  --bs-pagination-active-border-color: #f09502;\n  --bs-pagination-disabled-color: rgba(255, 255, 255, 0.5);\n  --bs-pagination-disabled-bg: transparent;\n  --bs-pagination-disabled-border-color: rgba(240, 149, 2, 0.3);\n}\n\n.page-link {\n  background-color: rgba(255, 255, 255, 0.1);\n  border-color: rgba(240, 149, 2, 0.3);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.page-link:hover {\n  background-color: rgba(240, 149, 2, 0.2);\n  border-color: #f09502;\n  color: #fff;\n}\n\n.page-item.active .page-link {\n  background-color: #f09502;\n  border-color: #f09502;\n  color: #fff;\n}\n\n.page-item.disabled .page-link {\n  background-color: transparent;\n  border-color: rgba(240, 149, 2, 0.3);\n  color: rgba(255, 255, 255, 0.5);\n  cursor: not-allowed;\n}\n\n/* Mejoras de accesibilidad */\n.btn:focus {\n    box-shadow: 0 0 0 0.2rem rgba(240, 149, 2, 0.5);\n}\n\n.form-control:focus,\n.form-select:focus {\n    outline: none;\n}\n\n/* Estilos para el contador de resultados */\n.alert {\n    border-radius: 8px;\n    margin-bottom: 1.5rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
